import React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const Assistant: React.FC<Props> = ({ className, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M12,6.5a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,12,6.5ZM12,3.5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,3.5Z"
        fill="currentColor"
      />
      <circle
        cx="12"
        cy="10"
        r="5"
        fill="currentColor"
      />
      <path
        d="M17,14.5c-.64,0-3.5,1.73-5,2.5-1.5-.77-4.36-2.5-5-2.5A3.5,3.5,0,0,0,3.5,18v3a.5.5,0,0,0,.5.5H20a.5.5,0,0,0,.5-.5V18A3.5,3.5,0,0,0,17,14.5Z"
        fill="currentColor"
      />
      <path
        d="M15.78,11a2.5,2.5,0,0,0,.72-1.75,2.5,2.5,0,0,0-2.5-2.5,2.5,2.5,0,0,0-2,1,2.5,2.5,0,0,0-2-1,2.5,2.5,0,0,0-2.5,2.5A2.5,2.5,0,0,0,8.22,11a1.75,1.75,0,0,0,0,2,2.5,2.5,0,0,0-.72,1.75,2.5,2.5,0,0,0,2.5,2.5,2.5,2.5,0,0,0,2-1,2.5,2.5,0,0,0,2,1,2.5,2.5,0,0,0,2.5-2.5,2.5,2.5,0,0,0-.72-1.75A1.75,1.75,0,0,0,15.78,11Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default Assistant;